<template>
  <section
    class="n-section-primary !tw-pt-0"
    :class="{
      '!tw-pb-0': variant === variants.V3Blogs,
    }"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div
      class="tw-flex tw-w-full tw-flex-col container"
      :class="variants.V2Faqs === variant ? 'tw-items-start tw-justify-start' : 'tw-items-center tw-justify-center'"
    >
      <div
        class="tw-flex tw-w-full tw-flex-col tw-space-y-4 md:tw-flex-row md:tw-space-x-4 md:tw-space-y-0 lg:-tw-mt-16"
        :class="variant === variants.V1Guides || variant === variants.V3Blogs ? 'tw-mb-5 tw-w-full' : 'tw-mb-0'"
      >
        <intro-section version="v4" :component="component" :variables="vars" :tabs="allowedTabs" :active-tab="activeTab" />
      </div>

      <div v-if="variant === variants.V2Faqs" class="tw-my-5 tw-w-full">
        <search-box
          v-if="vars.isSearchActiveBool"
          ref="searchBox"
          v-model="faqSearchKeyword"
          :search-result-list="searchResultList"
          :search-method="onSearchFaqs"
          placeholder="Search"
        />
      </div>

      <div class="tw-w-full tw-py-10 tw-text-left lg:tw-py-20" v-if="variant === variants.V1Guides && !vars.searchBoxFullSizeBool">
        <h2>
          <span v-if="guides" :class="{ 'n-title-secondary': vars.coloredCountBool }">{{ guides.length }}</span>
          <template v-if="vars.titleText">
            {{ vars.titleText }}
          </template>
          <template v-else>
            RESULTS
          </template>
        </h2>
      </div>


      <div v-if="variant === variants.V1Guides" class="tw-grid tw-w-full tw-grid-cols-12 tw-gap-x-8 tw-gap-y-8">
        <!-- When searchBoxFullSizeBool is true, show Results and sub tabs on same line, then search box below -->
        <template v-if="vars.searchBoxFullSizeBool">
          <div class="tw-col-span-12">
            <!-- Results and Sub Tabs on same line -->
            <div class="tw-flex tw-flex-col lg:tw-flex-row tw-justify-between tw-items-start lg:tw-items-center tw-gap-4 tw-mb-6">
              <!-- Results Title -->
              <div class="tw-py-5 lg:tw-py-10">
                <h2>
                  <span v-if="guides" :class="{ 'n-title-secondary': vars.coloredCountBool }">{{ guides.length }}&nbsp;</span>
                  <template v-if="vars.titleText">
                    {{ vars.titleText }}
                  </template>
                  <template v-else>
                    RESULTS
                  </template>
                </h2>
              </div>
              
              <!-- Sub Tabs -->
              <div v-if="vars.showSubMenuBool" class="tw-flex tw-flex-wrap tw-justify-center lg:tw-justify-end tw-gap-2">
                <template v-if="vars.buttonTypeText === 'standard'">
                  <button
                  v-for="tab in subTabs"
                  :key="tab.name"
                  class="tw-px-4 tw-py-2 tw-border-none tw-bg-transparent !tw-font-semibold !tw-text-xl"
                  :style="{
                    color: activeSubTab === tab.name 
                      ? 'var(--c-primary)'
                      : 'var(--c-text_primary)'
                  }"
                  @click="selectSubTab(tab.name)"
                >
                  {{ tab.title }}
                </button>
                </template>
                <template v-else>
                  <button
                  v-for="tab in subTabs"
                  :key="tab.name"
                  class="tw-px-4 tw-py-2 tw-border-none tw-bg-transparent !tw-font-semibold !tw-text-xl"
                  :style="{
                    color: activeSubTab === tab.name 
                      ? (['landlords', 'tenants'].includes(tab.name) 
                        ? 'var(--c-tertiary)' 
                        : ['buyers', 'sellers'].includes(tab.name) 
                          ? 'var(--c-secondary)' 
                          : 'var(--c-primary)')
                      : 'var(--c-text_tertiary)'
                  }"
                  @click="selectSubTab(tab.name)"
                >
                  {{ tab.title }}
                </button>
                </template>
              </div>
            </div>
            
            <!-- Search Box below -->
            <div class="tw-flex tw-justify-center">
              <search-box
                v-model="guideSearchKeyword"
                :search-result-list="[]"
                :search-method="onSearchGuides"
                placeholder="Search by name"
              />
            </div>
          </div>
        </template>
        
        <!-- When searchBoxFullSizeBool is false, keep original layout -->
        <template v-else>
          <div class="tw-col-span-12">
            <div class="tw-grid tw-grid-cols-1 xl:tw-grid-cols-2 tw-gap-4 tw-items-center">
              <!-- Search Box-->
              <search-box
                v-model="guideSearchKeyword"
                :search-result-list="[]"
                :search-method="onSearchGuides"
                placeholder="Search by name"
              />  
              
              <!-- Sub Tabs-->
              <div class="tw-flex tw-flex-wrap tw-justify-center xl:tw-justify-end tw-gap-2">
                <template v-if="vars.buttonTypeText === 'standard'">
                  <button
                  v-for="tab in subTabs"
                  :key="tab.name"
                  class="tw-px-4 tw-py-2 tw-border-none tw-bg-transparent !tw-font-semibold !tw-text-xl"
                  :style="{
                    color: activeSubTab === tab.name 
                      ? 'var(--c-primary)'
                      : 'var(--c-text_primary)'
                  }"
                  @click="selectSubTab(tab.name)"
                >
                  {{ tab.title }}
                </button>
                </template>
                <template v-else>
                  <button
                  v-for="tab in subTabs"
                  :key="tab.name"
                  class="tw-px-4 tw-py-2 tw-border-none tw-bg-transparent !tw-font-semibold !tw-text-xl"
                  :style="{
                    color: activeSubTab === tab.name 
                      ? (['landlords', 'tenants'].includes(tab.name) 
                        ? 'var(--c-tertiary)' 
                        : ['buyers', 'sellers'].includes(tab.name) 
                          ? 'var(--c-secondary)' 
                          : 'var(--c-primary)')
                      : 'var(--c-text_tertiary)'
                  }"
                  @click="selectSubTab(tab.name)"
                >
                  {{ tab.title }}
                </button>
                </template>
              </div>
            </div>
          </div>
        </template>
        
        <!-- Guide Cards -->
        <div
          v-for="(guide, index) in guides"
          :key="`guide-${index}`"
          class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
          :class="guide.type === 'VIDEO' ? 'xl:tw-col-span-4' : 'xl:tw-col-span-3'"
        >
          <theme7-components-guide-card
            :guide="guide"
            :component="component"
            :index="index"
            :variables="vars"
            :version="vars.guideVersionText || 'v2'"
            @open-guide-popup="toggleGuidePopup(guide, true)"
          ></theme7-components-guide-card>
        </div>
        
        <!-- Popup -->
        <popup v-if="selectedGuide && popupConfig.isActive" :config="popupConfig" custom-width="80%">
          <template #content>
            <div class="tw-w-full tw-text-black">
              <div
                class="tw-mx-auto tw-flex tw-w-full tw-flex-col md:tw-w-[80%] lg:tw-w-full lg:tw-flex-row"
                style="border-radius: var(--rounded); background-color: var(--c-section_primary);"
              >
                <div class="tw-w-full lg:tw-max-w-[465px] tw-flex tw-justify-center tw-items-center">
                  <LibraryImage
                    :w-ratio="1"
                    :h-ratio="1.45"
                    :src="selectedGuide.photo"
                    style="border-radius: var(--rounded)"
                  />
                </div>
                <div class="tw-flex tw-w-full tw-flex-col tw-p-6 md:tw-p-10 xl:tw-px-20">
                <h3>{{selectedGuide.title}}</h3>
                  <library-form
                    v-if="selectedGuide.guide"
                    :form="parseFormV2(selectedGuide.guide)"
                    version="v2"
                    :component="component"
                    :custom-managed-form="managedFormVars"
                    :isFormNameVisible="false"
                  ></library-form>
                </div>
              </div>
            </div>
          </template>
        </popup>
      </div>

      <div v-if="variant === variants.V2Faqs" class="tw-w-full">
        <accordion v-if="!isFaqResultsLoading" :items="accordionFaqs" :show-numbers="false" />
        <loader v-show="isFaqResultsLoading" />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import { useWebsiteStore } from '~/units/website/store';
import { ComponentMixin } from '~/mixins/component.mixin';
import LibraryAccordion from '~/components/library/content/Accordion.vue';
import SearchBox from '~/components/common/SearchBox.vue';
import { SearchEngine } from '~/core/engines/search.engine';
import { sleep } from '~/helpers';
import Loader from '~/components/common/Loader.vue';
import BlogsPage from '~/components/theme5/blogs/BlogsPage.vue';
import IntroSection from '~/components/theme7/components/IntroSection.vue';
import Popup from '~/components/common/popup/Popup.vue';
import Accordion from '~/components/theme7/components/Accordion.vue';

export default defineNuxtComponent({
  name: 'Theme7KnowledgeHubPage',

  components: {
    Loader,
    SearchBox,
    LibraryAccordion,
    BlogsPage,
    IntroSection,
    Popup,
    Accordion,
  },

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        V1Guides: 'V1Guides',
        V2Faqs: 'V2Faqs',
        V3Blogs: 'V3Blogs',
      },

      guideSearchKeyword: '',
      faqSearchKeyword: '',
      searchResultList: [],
      isFaqResultsLoading: false,

      selectedGuide: null,
      popupConfig: {
        isActive: false,
      },
      form: null,
    };
  },

  created() {
    const route = useRoute();
    if (route.query.q && this.activeTab === 'faqs') {
      this.faqSearchKeyword = route.query.q;
    }
  },

  computed: {
    ...mapState(useWebsiteStore, ['company']),
    
    tabs() {
      // İzin verilen şirketleri tanımlıyoruz
      const allowedCompanies = ['harrisandwood'];
      const isAllowedCompany = this.company?.company_key ? allowedCompanies.includes(this.company.company_key) : false;
      
      return [
        {
          title: 'WRITTEN GUIDES',
          name: 'written-guides',
          active: true,
        },
        {
          title: 'VIDEO GUIDES',
          name: 'video-guides',
          active: true,
        },
        {
          title: 'WRITTEN FAQS',
          name: 'written-faqs',
          active: isAllowedCompany
        },
        {
          title: 'VIDEO FAQS',
          name: 'video-faqs',
          active: isAllowedCompany
        },
        {
          title: 'Blog',
          name: 'blog',
          active: true
        },
        /*
        {
          title: 'Area Guides',
          name: 'area-guides',
          active: false,
        },
        */
      ];
    },

    // Sadece izin verilen tab'ları döndüren computed property
    allowedTabs() {
      return this.tabs.filter(tab => tab.active);
    },

    managedFormVars() {
      if (this.selectedGuide) {
        return {
          isNeuronManagedFormBool: this.selectedGuide.is_neuron_managed_form,
          formRedirectUrlText: this.selectedGuide.form_redirect_url,
          formInternalTitleForCustomerText: this.selectedGuide.form_internal_title_for_customer,
        };
      }
    },

    activeTab() {
      return this.vars.activeTabText;
    },

    activeSubTab() {
      const route = useRoute();

      if (route.query.type === 'buyers') {
        return 'buyers';
      } else if (route.query.type === 'tenants') {
        return 'tenants';
      } else if (route.query.type === 'sellers') {
        return 'sellers';
      } else if (route.query.type === 'landlords') {
        return 'landlords';
      }
      return '';
    },

    subTitle() {
      return this.vars.subTabTitleText;
    },

    subTabs() {
      return [
        {
          title: 'All',
          name: '',
        },
        {
          title: 'Buyers',
          name: 'buyers',
        },
        {
          title: 'Sellers',
          name: 'sellers',
        },
        {
          title: 'Landlords',
          name: 'landlords',
        },
        {
          title: 'Tenants',
          name: 'tenants',
        },
      ];
    },

    guides() {
      let filteredGuides = this.groupedVariables.guides;
      
      // Filter by search keyword if present
      if (this.guideSearchKeyword) {
        const searchEngine = new SearchEngine();
        filteredGuides = searchEngine.searchInArray(filteredGuides, ['title', 'description'], this.guideSearchKeyword);
      }
      
      // Apply group type filtering if active sub tab is selected
      if (this.activeSubTab) {
        const validTypes = ['buyers', 'tenants', 'landlords', 'sellers'];

        return filteredGuides.filter((guide) => {
          if (validTypes.includes(this.activeSubTab)) {
            return guide.group_type === this.activeSubTab;
          }

          return false;
        });
      }

      return filteredGuides;
    },

    faqs() {
      const route = useRoute();
      if (route.query.q) {
        const keyword = route.query.q as string;

        const searchEngine = new SearchEngine();

        return searchEngine.searchInArray(this.groupedVariables.faqs, ['title', 'description'], keyword);
      }
      return this.groupedVariables.faqs;
    },

    // Transform FAQ data to match Theme7 Accordion component format
    accordionFaqs() {
      return this.faqs.map(faq => ({
        title: faq.title,
        content: faq.description,
        html: true
      }));
    },
  },

  methods: {
    async onSearchGuides() {
      // You can implement additional functionality here if needed
      // For now, it just updates the search and the guides computed property will handle filtering
    },

    selectSubTab(tabName: string) {
      const router = useRouter();
      if (tabName) {
        router.push({ query: { type: tabName } });
      } else {
        router.push({ query: {} });
      }
    },

    async onSearchFaqs() {
      this.isFaqResultsLoading = true;
      const router = useRouter();

      await sleep(1000);

      await router.replace({
        query: {
          q: this.faqSearchKeyword,
        },
      });
      this.isFaqResultsLoading = false;
    },

    toggleGuidePopup(guide = null, value = false) {
      if (guide.title) {
        this.selectedGuide = guide;
        this.form = this.parseFormV2(guide.popup);
        this.popupConfig.isActive = value;
      }
    },
  },
});
</script>

<style scoped>
.n-tertiary:hover {
  background-color: white;
  color: unset;
  border-color: var(--c-primary);
}

::v-deep(.accordion-list:not(:last-child)) {
  border-bottom: 1px solid var(--c-border);
}

::v-deep(.blogs-page) {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
</style>
